import React, { useContext } from 'react'
import { Col, Row, Card } from '@themesberg/react-bootstrap'
import { Context } from '../UnmarketableTickets'

const Summary = () => {

  const { state } = useContext(Context);
  const { summary } = state;

  const formatNumber = (num) => {
    return new Intl.NumberFormat('vi-VN').format(num || 0)
  }

  return (
    <Row>
      <Col md={3}>
        <Card border="light" className="shadow-sm">
          <Card.Body>
            <h6 className="text-muted">Tổng vé ế</h6>
            <h4>{formatNumber(summary.totalAmount)} vé</h4>
            <small className="text-muted">
              {formatNumber(summary.total)} dãy số
            </small>
          </Card.Body>
        </Card>
      </Col>
      <Col md={3}>
        <Card border="light" className="shadow-sm bg-success text-white">
          <Card.Body>
            <h6>Trúng thưởng</h6>
            <h4>{formatNumber(summary.wonAmount)} vé</h4>
            <small>
              {formatNumber(summary.wonCount)} dãy số | Thưởng: {formatNumber(summary.wonRewardAmount)}đ
            </small>
          </Card.Body>
        </Card>
      </Col>
      <Col md={3}>
        <Card border="light" className="shadow-sm">
          <Card.Body>
            <h6 className="text-muted">Không trúng</h6>
            <h4>{formatNumber(summary.notWonAmount)} vé</h4>
            <small className="text-muted">
              {formatNumber(summary.notWonCount)} dãy số
            </small>
          </Card.Body>
        </Card>
      </Col>
      <Col md={3}>
        <Card border="light" className="shadow-sm bg-warning">
          <Card.Body>
            <h6>Chờ tính thưởng</h6>
            <h4>{formatNumber(summary.pendingAmount)} vé</h4>
            <small>
              {formatNumber(summary.pendingCount)} dãy số
            </small>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default React.memo(Summary)
